import { keyframes } from 'styled-components'

export const fadeZoomOut = keyframes`
  from {
    transform: scale(1);
    opacity: 0;
  }

  to {
    transform: scale(0.5);
    opacity: 1;
  }
`
